import React from "react";
import { Star } from "lucide-react";

/** Phase 8: compact org rating chip for opportunity cards — "★ 4.5 (2)".
 *  Renders nothing when the org has no (unflagged) feedback. */
export function OrgRatingChip({ rating, testId }) {
  if (!rating || !rating.count) return null;
  return (
    <span
      data-testid={testId || "org-rating-chip"}
      title={`${rating.average} average from ${rating.count} volunteer review${rating.count === 1 ? "" : "s"}`}
      className="inline-flex items-center gap-1 rounded-full bg-amber-50 border border-amber-200 text-amber-700 text-[11px] font-semibold px-2 py-0.5"
    >
      <Star className="w-3 h-3 fill-amber-500 text-amber-500" />
      {rating.average.toFixed(1)} <span className="font-normal">({rating.count})</span>
    </span>
  );
}
